import { Component, OnInit } from '@angular/core';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { first } from 'rxjs';
import { ReportsService } from 'src/app/services/reports.service';
import { MenuItem, MessageService } from 'primeng/api';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

import saveAs from 'file-saver';
@Component({
  selector: 'app-mi-da-report',
  templateUrl: './mi-da-report.component.html',
  styleUrls: ['./mi-da-report.component.scss']
})
export class MiDaReportComponent implements OnInit {
 date:any;
 userId:any;
 pondData:any;
 appVerificationItems: MenuItem[];
 appVerificationModel:any;
 cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
 exportColumns: { title: string; dataKey: string; }[];
  constructor(private service: BaseService, private cryptoJsService: CryptoJsService, private loader: AppLoaderService,private reportsService:ReportsService,private messageService:MessageService,private cryptoJs: CryptoJsService) { }

  ngOnInit(): void {
    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const userId = loginDetails.get('User_name_while_login') ? loginDetails.get('User_name_while_login') : null;

    this.userId = userId;
    // console.log(this.userId,"this.userIdthis.userIdthis.userIdthis.userIdthis.userIdthis.userId")
    // this.userId=encodeURIComponent(this.cryptoJs.Encrypt(this.userId))
 this.service.selectedDate.subscribe(res => this.date = res);
 this.loadData()
 this.appVerificationItems = [
  {
    label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
      this.exportExcel(this.appVerificationModel, "DA_wise_report");
    }
  },
  // {
  //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
  //     this.downloadSheetAsPdf(this.appVerificationModel, "DA_wise_report");
  //   }
  // },
];

  }
  // ngOnChanges() {
  //   // changes.prop contains the old and the new value...
  //   this.service.selectedDate.subscribe(res => {
  //     if(this.date !== res){
  //       this.date=res;
  //       this.loadData()
  //     }
  //   });

  // }
  loadData(){
    this.loader.start();
    this.reportsService.getDDAssociateDailyTaskMI(this.userId,this.date,'')
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.loader.close();
            // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), 'Success');
            data.forEach(e=>{
              e.Date=new Date(e.Date)
              e.Date_filter=e.Date.toString().substr(4,11)

            })
            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.pondData=data
              this.appVerificationModel = data;
            }
          },
          error: (err) => {
            this.loader.close();
            // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
  }
  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "UserId" : d.UserID,
          "Date": d.Date_filter,
          "District": d.District,
          "Applicant Type": d.Applicant_type,
          "Application Approval":d.ApplicationApproval,
          "ApplicationApproval MR": d.ApplicationApproval_MR,
          "EstimateApproval": d.EstimateApproval,
          "EstimateApproval MR": d.EstimateApproval_MR,
          "PV Approval": d.PVApproval,
          "PV Approval MR": d.PVApproval_MR,

        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      ); 
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'UserID', header: 'UserId'},
      { field: 'Date', header: 'Date' },
      { field: 'District', header: 'District' },
      { field: 'Applicant_type', header: 'Applicant Type' },
      { field: 'ApplicationApproval', header: 'Application Approval' },
      { field: 'ApplicationApproval_MR', header: 'ApplicationApproval MR' },
      { field: 'EstimateApproval', header: 'Estimate Approval' },
      { field: 'EstimateApproval_MR', header: 'Estimate Approval MR' },
      { field: 'PVApproval', header: 'PV Approval' },
      { field: 'PVApproval_MR', header: 'PV Approval MR' },

    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }

}
